var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCross = function SvgCross(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M16.576 7.951 12.533 12l4.043 4.049-.527.527L12 12.533l-4.049 4.043-.527-.527L11.467 12 7.424 7.951l.527-.527L12 11.467l4.049-4.043z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };